import clsx from "clsx";
import { omit } from "lodash";
import type { ButtonHTMLAttributes, JSX, PropsWithChildren } from "react";

type ButtonProps = PropsWithChildren<
	ButtonHTMLAttributes<HTMLButtonElement> & {
		primary?: boolean;
		secondary?: boolean;
		danger?: boolean;
		success?: boolean;
		outline?: boolean;
		link?: boolean;
		linkWithoutBackgound?: boolean;
		underline_link?: boolean;
		endIcon?: JSX.Element;
		startIcon?: JSX.Element;
		isSelected?: boolean;
	}
>;

const Button = ({
	primary,
	secondary,
	danger,
	success,
	outline,
	link,
	linkWithoutBackgound,
	underline_link,
	endIcon,
	startIcon,
	className,
	isSelected,
	children,
	...props
}: ButtonProps) => {
	if (outline)
		return (
			<button
				className={clsx(
					"outline-button",
					{
						"outline-button--secondary": secondary,
						"outline-button--danger": danger,
						"outline-button-with-icon": startIcon || endIcon,
						"outline-button-with-icon--start": startIcon,
						"outline-button-with-icon--end": endIcon,
						"outline-button--selected": isSelected,
					},
					className,
				)}
				{...omit(props, ["primary"])}
			>
				{startIcon}
				{children}
				{endIcon}
			</button>
		);

	if (link || underline_link || linkWithoutBackgound)
		return (
			<button
				className={clsx(
					"button-link",
					{
						"button-link--secondary": secondary,
						"button-link--danger": danger,
						"button-link--success": success,
						"button-link-with-icon": startIcon || endIcon,
						"button-link-with-icon--start": startIcon,
						"button-link-with-icon--end": endIcon,
						"button-link--underline": underline_link,
						"button-link--without-background": linkWithoutBackgound,
					},
					className,
				)}
				{...props}
			>
				{startIcon ? startIcon : null}
				{children}
				{endIcon ? endIcon : null}
			</button>
		);
	return (
		<button
			className={clsx(
				"button",
				{
					"button--secondary": secondary,
					"button--danger": danger,
					"button-with-icon": startIcon || endIcon,
					"button-with-icon--start": startIcon,
				},
				className,
			)}
			{...props}
		>
			{startIcon ? startIcon : null}
			{children}
			{endIcon ? endIcon : null}
		</button>
	);
};

export { Button };
